export interface ChatChannel {
	['channel_sid']: string
	created: string
	pinned?: boolean
	patientData: {
		phone?: string
		lastName: string
		firstName: string
		imageUrl?: string
		gender?: string
		email: string
		ID: string
	}
	['provisioning_id']: string
	['unique_name']: string
}

export interface ChatMessage {
	items: Array<ChatMessageItem>
}
export interface ChatMessageItem {
	state: {
		author: string
		body: string
	}
	type: string
	media: any
	channel: any
	index: number
	conversation: any
	sid: string
	author: string
	dateCreated: string
}
export interface ChatDayItem {
	date: string
	messages: Array<ChatMessageItem>
}
export interface ClientUnreadCountItem {
	sid: string
	num: number
}

/**
 * Chat state
 */

export interface ChatState {
	message: Array<any>
	channelSid: string
	outMessage: string
	usersChannels: Array<ChatChannel>
	userChatId: string
	chatNails: Array<string>
	isUploadNewMsgs: boolean
	isGetConsumedIndex: boolean
	isLastConsumed: any
	clientUnreadCount: Array<ClientUnreadCountItem>
	chatSearch: string
}

export enum CHAT_ACTION_TYPES {
	SET_MESSAGE = 'SET_MESSAGE',
	SET_NEW_MESSAGE = 'SET_NEW_MESSAGE',
	SET_CHENNEL_SID = 'SET_CHENNEL_SID',
	SET_OUT_MESSAGE = 'SET_OUT_MESSAGE',
	SET_USERS_CHANNELS = 'SET_USERS_CHANNELS',
	SET_USER_CHAT_ID = 'SET_USER_CHAT_ID',
	SET_CHAT_NAILS = 'SET_CHAT_NAILS',
	SET_CHAT_MORE_MSGS = 'SET_CHAT_MORE_MSGS',
	SET_CHAT_CONSUMED = 'SET_CHAT_CONSUMED',
	SET_LAST_CONSUMED = 'SET_LAST_CONSUMED',
	SET_CLIENT_UNREAD_COUNT = 'SET_CLIENT_UNREAD_COUNT',
	SET_CHAT_SEARCH = 'SET_CHAT_SEARCH',
}

export interface ChatSetConsumed {
	type: CHAT_ACTION_TYPES.SET_CHAT_CONSUMED
	payload: boolean
}
export interface ChatSetMessage {
	type: CHAT_ACTION_TYPES.SET_MESSAGE
	payload: Array<ChatMessageItem>
}
export interface ChatSetNewMessage {
	type: CHAT_ACTION_TYPES.SET_NEW_MESSAGE
	payload: ChatMessageItem
}
export interface ChatSetChannelSid {
	type: CHAT_ACTION_TYPES.SET_CHENNEL_SID
	payload: string
}
export interface ChatSetOutMessage {
	type: CHAT_ACTION_TYPES.SET_OUT_MESSAGE
	payload: string
}
export interface ChatSetUserId {
	type: CHAT_ACTION_TYPES.SET_USER_CHAT_ID
	payload: string
}
export interface ChatSetUsersChannels {
	type: CHAT_ACTION_TYPES.SET_USERS_CHANNELS
	payload: Array<ChatChannel>
}
export interface ChatSetNails {
	type: CHAT_ACTION_TYPES.SET_CHAT_NAILS
	payload: Array<string>
}
export interface ChatSetMoreMsgs {
	type: CHAT_ACTION_TYPES.SET_CHAT_MORE_MSGS
	payload: boolean
}
export interface ChatSetLastConsumed {
	type: CHAT_ACTION_TYPES.SET_LAST_CONSUMED
	payload: any
}
export interface ChatSetClientUnreadCount {
	type: CHAT_ACTION_TYPES.SET_CLIENT_UNREAD_COUNT
	payload: ClientUnreadCountItem
}
export interface ChatSetSearch {
	type: CHAT_ACTION_TYPES.SET_CHAT_SEARCH
	payload: string
}

export enum ChatEvents {
	TOKEN_ABOUT_TO_EXPIRE = 'tokenAboutToExpire',
	TOKEN_EXPIRED = 'tokenExpired',
	MESSAGE_ADDED = 'messageAdded',
	PARTICIPANT_UPDATED = 'participantUpdated',
	CONVERSATION_UPDATED = 'conversationUpdated',
}

export interface MessageProps {
	sid: string
	author: string | null
	body: string | null
	dateCreated: Date | null
	isOutgoing: boolean
	index: number
	friendlyName: string | null
}

export type ChatActions =
	| ChatSetMessage
	| ChatSetNewMessage
	| ChatSetChannelSid
	| ChatSetOutMessage
	| ChatSetUsersChannels
	| ChatSetUserId
	| ChatSetNails
	| ChatSetMoreMsgs
	| ChatSetConsumed
	| ChatSetLastConsumed
	| ChatSetClientUnreadCount
	| ChatSetSearch
